"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genCsrfToken = void 0;

var sha256_1 = __importDefault(require("crypto-js/sha256"));

var enc_hex_1 = require("crypto-js/enc-hex");

function genCsrfToken(data) {
  var keys = Object.keys(data.payload).sort();
  var preparedPayload = {};
  keys.forEach(function (k) {
    return preparedPayload[k] = data.payload[k];
  });
  var clCsrf = "".concat(sha256_1.default(data.userAgent).words.sort(), "_").concat(data.userAgent, "_").concat(JSON.stringify(preparedPayload), "_").concat(keys.reverse());
  return enc_hex_1.stringify(sha256_1.default(clCsrf));
}

exports.genCsrfToken = genCsrfToken;